<template>
  <!-- 文本答案 -->
  <div class="text-message response">
    <em class="icon-dot"></em>
    <div class="text-message__txt" v-html="message.content"></div>
  </div>
</template>

<script>
export default {
  name: 'BubbleTextResponse',
  props: {
    message: Object
  }
}
</script>
